export default "__VITE_PUBLIC_ASSET__59acf4e0__"